import {
	createState,
} from './simpleDataList';

import {
	loadSitemapsRangeViaApi,
} from '~/model/sitemaps';



export const {
	loadData,
	reducer,
	selector,
} = createState(
	'sitemapsViolatingFilesizeLimit',
	(websiteId) => loadSitemapsRangeViaApi(websiteId, {
		'fields': 'url,size_uncompressed',
		'filter[size_uncompressed]': '>52428800',
		'offset': 0,
		'limit': 1000,
	}),
	30,
);
